export const SpecialtyLinks = [
    { text: 'Primary Care Doctor', href: 'primary-care-doctors' },
    { text: 'Urgent Care', href: 'urgent-care' },
    { text: 'Dermatologist', href: 'dermatologists' },
    { text: 'OB-GYN', href: 'obgyns' },
    { text: 'Dentist', href: 'dentists' },
    { text: 'Psychiatrist', href: 'psychiatrists' },
    { text: 'Ear, Nose & Throat Doctor', href: 'ear-nose-throat-doctors' },
    { text: 'Podiatrist', href: 'podiatrists' },
    { text: 'Urologist', href: 'urologists' },
    { text: 'Gastroenterologist', href: 'gastroenterologists' },
    { text: 'Cardiologist', href: 'cardiologists' },
    { text: 'Neurologist', href: 'neurologists' },
    { text: 'Orthopedic Surgeon', href: 'orthopedic-surgeons' },
    { text: 'Ophthalmologist', href: 'ophthalmologists' },
    { text: 'Pediatrician', href: 'pediatricians' },
    { text: 'Optometrist', href: 'optometrists' },
    { text: 'Eye Doctor', href: 'eye-doctors' },
    { text: 'Therapist Counselor', href: 'therapist-counselors' },
    { text: 'Physical Therapist', href: 'physical-therapists' },
    { text: 'Psychologist', href: 'psychologists' },
    { text: 'View all', href: 'specialty' },
];

export const InsuranceLinks = [
    { text: 'Aetna', href: 'primary-care-doctors/aetna-300m' },
    { text: 'Aetna Dental', href: 'dentists/aetna-212d' },
    { text: 'Ambetter', href: 'primary-care-doctors/ambetter-1323m' },
    {
        text: 'Anthem Blue Cross Blue Shield',
        href: 'primary-care-doctors/anthem-blue-cross-blue-shield-324m',
    },
    {
        text: 'Blue Cross Blue Shield',
        href: 'primary-care-doctors/blue-cross-blue-shield-304m',
    },
    {
        text: 'Blue Cross Blue Shield Dental',
        href: 'dentists/blue-cross-blue-shield-448d',
    },
    { text: 'Cigna', href: 'primary-care-doctors/cigna-307m' },
    { text: 'Cigna Dental', href: 'dentists/cigna-222d' },
    { text: 'Delta Dental', href: 'dentists/delta-dental-223d' },
    {
        text: 'Florida Blue Cross Blue Shield',
        href:
            'primary-care-doctors/florida-blue-blue-cross-blue-shield-of-florida-638m',
    },
    { text: 'Humana Dental', href: 'dentists/humana-283d' },
    { text: 'Humana', href: 'primary-care-doctors/humana-315m' },
    {
        text: 'Kaiser Permanente',
        href: 'dentists/kaiser-permanente-375d',
    },
    { text: 'Metlife', href: 'dentists/metlife-239d' },
    {
        text: 'Multiplan PHCS',
        href: 'primary-care-doctors/multiplan-phcs-360m',
    },
    {
        text: 'UnitedHealthcare',
        href: 'primary-care-doctors/unitedhealthcare-323m',
    },
    {
        text: 'UnitedHealthcare Dental',
        href: 'dentists/unitedhealthcare-243d',
    },
    {
        text: 'UnitedHealthcare Oxford',
        href: 'primary-care-doctors/unitedhealthcare-oxford-330m',
    },
    { text: '1199SEIU', href: 'primary-care-doctors/1199seiu-440m' },
    { text: 'View all', href: 'specialty/insurances/primary-care-doctors' },
];
